const turnStore = {
  turn: {},
  store: {},
  turnInfo: {},
  storeCash: {},
}

export default turnStore
